import request from '../utils/request.js'
export function getAdvInfo(data){
  return request({
    url:'/api/v1/advanceInfo',
    method:'get',
    params:data
  })
}
export function getOauth(data){
  return request({
    url:'/api/v1/admin/getOauth',
    method:'post',
    data:data
  })
}


export function getAdminInfoLogin(){
  return request({
    url:'/api/v1/admin/getAdminInfoLogin',
    method:'get',
  })
}

/**
 * 创建栏目
 * @param channelName
 * @param channelImg
 * @returns {*}
 */
export function createMenu(data){
  return request({
    url:'/api/v1/admin/createMenu',
    method:'post',
    data:data
  })
}



// WEBPACK FOOTER //
// ./src/api/admin.js